import Icon from '@ant-design/icons';
import React from 'react';

/**
 * 顶栏「Ai agent」左侧：尖顶六边形外框（顶、底顶点断开）+ 尖顶 A + 水平横杠。
 * 描边随 currentColor（与 .qn-app-mode-icon 一致）。
 * viewBox 宽高比与 .qn-app-mode-icon--agent（约 1.28:1）一致，便于横向铺满。
 */
const AiAgentSvg: React.FC = () => (
  <svg
    viewBox="1.76 4 20.48 16"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
    focusable="false"
    style={{ display: 'block' }}
  >
    {/* 左半框：左上斜边 → 左竖 → 左下斜边（顶角、底角与右半框留缝，呈相对括号） */}
    <path
      d="M6 8L11.28 4.48M6 8L6 16M6 16L11.28 19.52"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* 右半框：右上斜边 → 右竖 → 右下斜边 */}
    <path
      d="M12.72 4.48L18 8L18 16L12.72 19.52"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* 字母 A：倒 V + 水平横杠 */}
    <path
      d="M9.2 15.6L12 9.8L14.8 15.6M10.3 12.9h3.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AiAgentIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon component={AiAgentSvg} className={className} />
);
